import { Component, OnInit } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'
import { Persona } from 'se-resource-types/dist/lib/UserService'

const exampleHtml = `
<se-po-persona-avatar
  subtitleLink="#"
  headerSubtitle="View my account"
  [persona]="persona">
</se-po-persona-avatar>
`

const exampleTypescript = `
import { Component, OnInit } from '@angular/core'
import { Persona } from 'se-resource-types/dist/lib/UserService'
export class PersonaAvatarSubtitleLinkExampleComponent implements OnInit {
  public persona: Persona
  public ngOnInit(): void {
    this.persona = {
      id: 6,
      date_of_birth: '2000-12-11',
      email_addresses: [{ address: 'test@test.com', is_primary: true }],
      first_name:'Another',
      gender: 'male',
      last_name: 'Test'
    } as Persona
  }
}
`

const template = `<se-fe-docs-example [example]="this">${ exampleHtml }</se-fe-docs-example>`

@Component({
  selector: 'se-po-persona-avatar-subtitle-link-example',
  template,
  styleUrls: ['./../persona-avatar-docs.component.scss'],
  standalone: false,
})
export class PersonaAvatarSubtitleLinkExampleComponent extends SeFeDocsExampleComponent implements OnInit {
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]
  public persona: Persona

  public ngOnInit(): void {
    this.persona = {
      id: 6,
      date_of_birth: '2000-12-11',
      first_name:'Another',
      gender: 'male',
      last_name: 'Test'
    } as Persona
  }
}
